import {
	PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
	PUBLIC_AUTH_AMBIGUOUS_ACCESS_MESSAGE,
	PUBLIC_AUTH_FOLDER_NOT_ACCESSIBLE_MESSAGE,
} from "@Front/constants/publicAuthUserMessages";

/**
 * Third-party public auth — keys match backend `ThirdPartyPublicAuthErrorCodes` values.
 */
export const COMMON_UI_I18N_PART2_SLICE_C = {
	thirdPartyPublicAuthErrors: {
		THIRD_PARTY_PUBLIC_AUTH_EMAIL_REQUIRED: "Email requis.",
		THIRD_PARTY_PUBLIC_AUTH_EMAIL_AND_CODE_REQUIRED: "Email et code requis.",
		THIRD_PARTY_PUBLIC_AUTH_SELECT_FOLDER_MISSING_FIELDS: "Email et identifiant de dossier requis.",
		THIRD_PARTY_PUBLIC_AUTH_SELECT_FOLDER_THIRD_PARTY_NOT_FOUND: PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_VERIFICATION_CODE_SEND_FAILED:
			"Erreur lors de l'envoi du code de vérification. Veuillez réessayer plus tard.",
		THIRD_PARTY_PUBLIC_AUTH_REFRESH_TOKEN_MISSING: "Jeton de rafraîchissement manquant.",
		THIRD_PARTY_PUBLIC_AUTH_REFRESH_TOKEN_INVALID: "Jeton de rafraîchissement invalide.",
		THIRD_PARTY_PUBLIC_AUTH_REFRESH_TOKEN_PAYLOAD_INVALID: "Jeton de rafraîchissement invalide (données incomplètes).",
		THIRD_PARTY_PUBLIC_AUTH_REFRESH_USER_TYPE_INVALID: "Type d'utilisateur incompatible avec le rafraîchissement tiers.",
		THIRD_PARTY_PUBLIC_AUTH_CODE_INVALID_OR_EXPIRED: "Code invalide ou expiré.",
		THIRD_PARTY_PUBLIC_AUTH_THIRD_PARTY_NOT_FOUND: PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_FOLDER_NOT_ACCESSIBLE: PUBLIC_AUTH_FOLDER_NOT_ACCESSIBLE_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_NARROW_OFFICE_EMPTY: PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_NARROW_AMBIGUOUS: PUBLIC_AUTH_AMBIGUOUS_ACCESS_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_NARROW_THIRD_PARTY_NOT_FOUND: PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
		THIRD_PARTY_PUBLIC_AUTH_NARROW_FOLDER_NOT_FOUND: PUBLIC_AUTH_ACCOUNT_NOT_FOUND_MESSAGE,
	},
} as const;
